import { render, staticRenderFns } from "./message.vue?vue&type=template&id=81119360&scoped=true&"
import script from "./message.vue?vue&type=script&lang=js&"
export * from "./message.vue?vue&type=script&lang=js&"
import style0 from "./message.vue?vue&type=style&index=0&id=81119360&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81119360",
  null
  
)

export default component.exports